
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en-gb/solutions/account-funding",
      function () {
        return require("private-next-pages/en-gb/solutions/account-funding.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en-gb/solutions/account-funding"])
      });
    }
  